import {err, ok, ValidationError} from 'framework';
import type {Result, Validator} from 'framework';
import * as z from 'zod';
import type {CreateWorkoutTemplateInput} from '../ports/workout.repository';
import {ExerciseIdValidator} from './exercise-id.validator';

export class CreateWorkoutTemplateDataValidator
  implements Validator<CreateWorkoutTemplateInput>
{
  private static readonly exerciseId = new ExerciseIdValidator();

  private static readonly templateExerciseSchema = z.strictObject({
    exerciseId: CreateWorkoutTemplateDataValidator.exerciseId.standardSchema,
    orderIndex: z.number().int().min(0).max(100).optional(),
    groupId: z.string().trim().min(1).max(64).nullable().optional(),
    targetSets: z.number().int().min(1).max(50).nullable().optional(),
    targetReps: z.number().int().min(1).max(500).nullable().optional(),
    targetWeightKg: z.number().min(0).max(2000).nullable().optional(),
    targetRestSeconds: z.number().int().min(0).max(3600).nullable().optional(),
    notes: z.string().trim().max(2000).nullable().optional(),
  });

  readonly standardSchema = z.strictObject({
    name: z.string().trim().min(1, 'Name is required.').max(120),
    notes: z.string().trim().max(4000).nullable(),
    exercises: z.array(CreateWorkoutTemplateDataValidator.templateExerciseSchema).max(50),
  });

  validate(value: unknown): Result<CreateWorkoutTemplateInput, ValidationError> {
    const parsed = this.standardSchema.safeParse(value);
    if (!parsed.success) {
      return err(
        new ValidationError(
          parsed.error.issues[0]?.message ?? 'Invalid create workout template data.',
        ),
      );
    }
    return ok(parsed.data);
  }
}
